import Signal from 'signals';
export default {
    zoomTo: new Signal(),
    zoomOut: new Signal(),
    filtersChanged: new Signal()
};
